import clsx from 'clsx'
import type { NodeRendererProps } from 'react-arborist'
import type { TreeItem } from '@/types'
import { useTidalSandboxStateField } from '../../atoms/tidalSandboxState.js'
import { NavigationNodeLabel } from './NavigationNodeLabel.js'
import { NavigationTreeNodeArrowIcon } from './NavigationTreeNodeArrowIcon.js'
import classes from './navigation-tree-node.module.css'

export function NavigationTreeNode({ node, style }: NodeRendererProps<TreeItem>) {
  const [navigationDisabled] = useTidalSandboxStateField('navigationDisabled')

  const isLeaf = node.isLeaf
  const isSelected = node.isSelected
  const isDisabled = isLeaf && navigationDisabled

  const rootClass = clsx(classes.root, {
    [classes.selected]: isSelected,
    [classes.disabled]: isDisabled,
    [classes.leaf]: isLeaf,
  })

  return (
    <div
      className={rootClass}
      data-node-type="navigation-tree-node"
      onClick={evt => {
        if (!isLeaf) {
          // prevent the internal nodes to be selected. Only the leaf nodes should be selectable.
          evt.stopPropagation()
        }
      }}
      onPointerDown={evt => {
        if (node.isInternal && !isLeaf) {
          node.toggle()
          evt.stopPropagation()
        }
        if (isLeaf) {
          node.handleClick(evt)
          node.select()
          node.activate()
        }
      }}
      style={style}
    >
      <div className={classes.layout}>
        <NavigationTreeNodeArrowIcon isLeaf={isLeaf} isOpen={node.isOpen} />
        <NavigationNodeLabel isLeaf={isLeaf} item={node.data} />
      </div>
    </div>
  )
}
